import { useEffect, useState } from 'react';
import '../styles/AnimatedIcon.css';

interface AnimatedIconProps {
  left: number;
  top: number;
  icon: string;
}

const AnimatedIcon: React.FC<AnimatedIconProps> = ({ left, top, icon }) => {
  const [visible, setVisible] = useState<boolean>(true);

  useEffect(() => {
    setTimeout(() => setVisible(false), 2000);
  }, []);

  return (
    <>
      {visible &&
        <span
          className='AnimatedIcon absolute select-none'
          style={{ left, top, zIndex: -1 }}
        >
          {icon}
        </span>}
    </>
  );
}

export default AnimatedIcon;
